import { Button } from 'react-bootstrap';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Styles from './aboutus.module.scss'; // Assuming you renamed the SCSS file
import aboutusImage from '../../assets/aboutus.webp';

const AboutUs = () => {
  const navigate = useNavigate();
  const navigateToAbout = () => {
		navigate('/about');
	}
  return (
    <div className={Styles.informationSec}>
      <div className={Styles.textContainer}>
          <div className={Styles.informationSecText}>
            <h1>About Us</h1>
            <p>
            Meet the dedicated team behind our project! Comprising three talented females, our team is passionate about creating innovative solutions. We are committed to delivering high-quality products that cater to your needs. Get to know us better as we work towards making a positive impact in the tech world.
            </p>
            <div onClick={navigateToAbout}><Button variant="secondary" className={Styles.informationSecButton}>
              Read More
              </Button>
            </div>
        </div>
      </div>
        <div className={Styles.image}>
          <img className={Styles.informationSecImage} src={aboutusImage} alt="aboutus" />
        </div>
      </div>
  );
};

export { AboutUs };
